import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import { dark, gray5 } from 'utils/color-styles';

export const normalStyle = {
  color: gray5,
  fontWeight: 400,
  fontSize: 14,
  marginTop: 15,
  marginRight: 25,
  paddingBottom: 14,
  display: 'inline-flex',
  cursor: 'pointer',
};

export const activeStyle = {
  ...normalStyle,
  color: dark,
  borderBottom: `1px solid ${dark}`,
  fontWeight: 500,
  marginBottom: 24,
  display: 'inline-flex',
};

const LinkTab = withRouter(({ path, label, location }) => (
  <Link style={location.pathname.includes(path) ? activeStyle : normalStyle} to={path}>
    {label}
  </Link>
));

export default LinkTab;
